import request from "../Utils/requests"
import {
	resetPassword,
	getProfile,
	// addCourse,
	userActions,
	addVideo,
} from "../Utils/requests"

//User account
export function login(params) {
	return request("auth/signin", { method: "POST", body: params })
}

export function register(params) {
	return request("auth/signUp", { method: "POST", body: params })
}
export function forgot(params) {
	return request("forgotPasswordOtp", { method: "POST", body: params })
}
export function resetpass(params) {
	return resetPassword("resetPassword", { method: "PUT", body: params })
}
export function profileGet() {
	return getProfile("getbyToken", { method: "GET" })
}
export function getUserByToken() {
	return request("auth/getbyToken", { method: "GET" })
}
export function profilePut(params) {
	return request("users/updateProfile", { method: "PUT", body: params })
}

//Questions Section
export function getQuestionByCategory(params) {
	return userActions("questionsByCategory", { method: "GET", body: params })
}
export function getQuestionsByUser(params) {
	return userActions("questionsByUser", { method: "GET", body: params })
}
export async function getAllQuestion() {
	return await request("getAllQuestions", { method: "GET" })
}

export function addQuestion(params) {
	return request("addQuestions", { method: "POST", body: params })
}

export function editQuestion(params) {
	return request("editQuestion", { method: "POST", body: params })
}
export function deleteQuestion(params) {
	return userActions("deleteQuestion", { method: "DELETE", body: params })
}

export function addCommentsToQuestions(params) {
	return request("addComments", { method: "POST", body: params })
}
export function getCategories() {
	return request("getCategory", { method: "GET" })
}

//VideoSection
export function editVideo(params) {
	return request("editVideo", { method: "PUT", body: params })
}

export function getVideoByCategory(params) {
	return userActions("videosByCategory", { method: "GET", body: params })
}
export function getVideosByUser(params) {
	return userActions("videosByUser", { method: "GET", body: params })
}
export function getAllVideos() {
	return request("getAllVideos", { method: "GET" })
}

export function addVideos(params) {
	return addVideo("addVideos", { method: "POST", body: params })
}
export function addCommentsVideos(params) {
	return request("addVideoComments", { method: "POST", body: params })
}
export function getVideoCategories() {
	return request("getAllVideosCategories", { method: "GET" })
}
export function deleteVideo(params) {
	return userActions("deleteVideo", { method: "DELETE", body: params })
}
